import { render, staticRenderFns } from "./articleList.vue?vue&type=template&id=2c9e6cac&scoped=true&"
import script from "./articleList.vue?vue&type=script&lang=js&"
export * from "./articleList.vue?vue&type=script&lang=js&"
import style0 from "./articleList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./articleList.vue?vue&type=style&index=1&id=2c9e6cac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9e6cac",
  null
  
)

export default component.exports